/**
 * ============================================================================
 * TaskFlow ERP
 * Module : Campaign Management
 * Feature: Prospect Import
 *
 * File:
 * src/modules/campaign/prospectImport/components/importWorkspace/drawers/CompareDrawer.jsx
 *
 * Description:
 * Compare imported prospect with existing ERP prospect.
 *
 * Responsibilities
 * ----------------
 * • Display Imported Record
 * • Display Existing Record
 * • Highlight Differences
 * • Help user decide which record to keep
 *
 * Read Only
 * No API Calls
 * ============================================================================
 */

import React from "react";

import {
    Offcanvas,
    Card,
    Row,
    Col,
    Table,
    Badge,
    Button
} from "react-bootstrap";

export default function CompareDrawer({

    show,

    config,

    state,

    actions

}) {

    // ==========================================================
    // STATE
    // ==========================================================

    const {

        selectedRecord

    } = state;

    // ==========================================================
    // ACTIONS
    // ==========================================================

    const {

        closeCompareDrawer

    } = actions;

    if (!selectedRecord) {

        return null;

    }

    /*
    ------------------------------------------------------------------
    Temporary Existing ERP Record

    Later this will come from
    campaignImportService.compareProspect()
    ------------------------------------------------------------------
    */

    const existingRecord = {

        name: "ABC Industries Pvt Ltd",

        external_id: "ERP000245",

        contacts: 3,

        industry: "Manufacturing",

        lead_source: "Referral",

        status: "Existing",

        email: "sales@abc.com",

        phone: "9876543210",

        gst: "27ABCDE1234F1Z5"

    };

    return (

        <Offcanvas

            show={show}

            onHide={closeCompareDrawer}

            placement="end"

            backdrop

            scroll={false}

            style={{

                width: "1000px"

            }}

        >

            {/* ====================================================== */}
            {/* HEADER */}
            {/* ====================================================== */}

            <Offcanvas.Header closeButton>

                <Offcanvas.Title>

                    <i className="fas fa-columns me-2 text-primary"></i>

                    Compare Prospect

                </Offcanvas.Title>

            </Offcanvas.Header>

            <Offcanvas.Body>

                <Row>

                    <Col lg={6}>

                        <Card>

                            <Card.Header
                                className="bg-primary text-white"
                            >

                                Imported Record

                            </Card.Header>

                            <Card.Body>

                                <Table
                                    borderless
                                    size="sm"
                                >

                                    <tbody>
                                                                            

                                        <tr>

                                            <th width="180">

                                                Prospect Name

                                            </th>

                                            <td>

                                                {selectedRecord.name}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                External ID

                                            </th>

                                            <td>

                                                {selectedRecord.external_id}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Contacts

                                            </th>

                                            <td>

                                                {selectedRecord.contacts}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Industry

                                            </th>

                                            <td>

                                                {selectedRecord.industry || "-"}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Lead Source

                                            </th>

                                            <td>

                                                {selectedRecord.lead_source || "-"}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Status

                                            </th>

                                            <td>

                                                <Badge bg="primary">

                                                    {selectedRecord.status}

                                                </Badge>

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Email

                                            </th>

                                            <td>

                                                {selectedRecord.email || "-"}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Phone

                                            </th>

                                            <td>

                                                {selectedRecord.phone || "-"}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                GST

                                            </th>

                                            <td>

                                                {selectedRecord.gst || "-"}

                                            </td>

                                        </tr>

                                    </tbody>

                                </Table>

                            </Card.Body>

                        </Card>

                    </Col>

                    {/* ====================================================== */}
                    {/* EXISTING ERP RECORD */}
                    {/* ====================================================== */}

                    <Col lg={6}>

                        <Card>

                            <Card.Header
                                className="bg-success text-white"
                            >

                                Existing ERP Record

                            </Card.Header>

                            <Card.Body>

                                <Table
                                    borderless
                                    size="sm"
                                >

                                    <tbody>

                                        <tr>

                                            <th width="180">

                                                Prospect Name

                                            </th>

                                            <td>

                                                {existingRecord.name}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                External ID

                                            </th>

                                            <td>

                                                {existingRecord.external_id}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Contacts

                                            </th>

                                            <td>

                                                {existingRecord.contacts}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Industry

                                            </th>

                                            <td>

                                                {existingRecord.industry}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Lead Source

                                            </th>

                                            <td>

                                                {existingRecord.lead_source}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Status

                                            </th>

                                            <td>

                                                <Badge bg="success">

                                                    Existing

                                                </Badge>

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Email

                                            </th>

                                            <td>

                                                {existingRecord.email}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                Phone

                                            </th>

                                            <td>

                                                {existingRecord.phone}

                                            </td>

                                        </tr>

                                        <tr>

                                            <th>

                                                GST

                                            </th>

                                            <td>

                                                {existingRecord.gst}

                                            </td>

                                        </tr>

                                    </tbody>

                                </Table>

                            </Card.Body>

                        </Card>

                    </Col>

                </Row>
                                {/* ====================================================== */}
                {/* DIFFERENCE SUMMARY */}
                {/* ====================================================== */}

                <Card className="mt-4">

                    <Card.Header>

                        <strong>

                            Difference Summary

                        </strong>

                    </Card.Header>

                    <Card.Body>

                        <Row>

                            <Col md={4}>

                                <div className="text-center">

                                    <h3 className="text-success">

                                        5

                                    </h3>

                                    <small>

                                        Matching Fields

                                    </small>

                                </div>

                            </Col>

                            <Col md={4}>

                                <div className="text-center">

                                    <h3 className="text-warning">

                                        3

                                    </h3>

                                    <small>

                                        Different Fields

                                    </small>

                                </div>

                            </Col>

                            <Col md={4}>

                                <div className="text-center">

                                    <h3 className="text-danger">

                                        1

                                    </h3>

                                    <small>

                                        Missing Fields

                                    </small>

                                </div>

                            </Col>

                        </Row>

                        <hr />

                        <div>

                            <div className="mb-2">

                                <i className="fas fa-check-circle text-success me-2"></i>

                                Industry matches

                            </div>

                            <div className="mb-2">

                                <i className="fas fa-check-circle text-success me-2"></i>

                                Email matches

                            </div>

                            <div className="mb-2">

                                <i className="fas fa-exclamation-triangle text-warning me-2"></i>

                                Prospect Name differs

                            </div>

                            <div className="mb-2">

                                <i className="fas fa-exclamation-triangle text-warning me-2"></i>

                                Contacts differ

                            </div>

                            <div>

                                <i className="fas fa-times-circle text-danger me-2"></i>

                                GST missing in imported record

                            </div>

                        </div>

                    </Card.Body>

                </Card>

                {/* ====================================================== */}
                {/* ACTION BUTTONS */}
                {/* ====================================================== */}

                <div className="d-flex justify-content-between mt-4">

                    <Button

                        variant="outline-primary"

                        onClick={() =>

                            console.log("Keep Imported")

                        }

                    >

                        <i className="fas fa-file-import me-2"></i>

                        Keep Imported

                    </Button>

                    <div>

                        <Button

                            variant="outline-success"

                            className="me-2"

                            onClick={() =>

                                console.log("Keep Existing")

                            }

                        >

                            <i className="fas fa-database me-2"></i>

                            Keep Existing

                        </Button>

                        <Button

                            variant="secondary"

                            onClick={closeCompareDrawer}

                        >

                            <i className="fas fa-times me-2"></i>

                            Close

                        </Button>

                    </div>

                </div>
                            </Offcanvas.Body>

        </Offcanvas>

    );

}